import { render } from "./hotQuesHome.vue?vue&type=template&id=616061e4&scoped=true"
import script from "./hotQuesHome.vue?vue&type=script&lang=js"
export * from "./hotQuesHome.vue?vue&type=script&lang=js"

import "./hotQuesHome.vue?vue&type=style&index=0&id=616061e4&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616061e4"]])

export default __exports__